import {
  SAVE_FORM_DATA_PART_ONE,
  SAVE_FORM_DATA_PART_ONE_SUCCESS,

  SAVE_FORM_DATA_PART_TWO,
  SAVE_FORM_DATA_PART_TWO_SUCCESS,

  SAVE_FORM_DATA_PART_THREE,
  SAVE_FORM_DATA_PART_THREE_SUCCESS,
  SEND_TRAINING_REG_DATA_TO_API,

  TREG_FETCH_ALL_STATES,
  TREG_FETCH_ALL_STATES_SUCCESS,

  REGISTER_TRAINING_CENTRE,
  REGISTER_TRAINING_CENTRE_SUCCESS,
  REGISTER_TRAINING_CENTRE_FAILURE,
  RESET_TRAINING_CENTRE_REG,

  FETCH_ALL_ACTIVE_SKILLS_TREG,
  FETCH_ALL_ACTIVE_SKILLS_TREG_SUCCESS,

  NEXT_FORM_STEP,
  PREVIOUS_FORM_STEP,
  RESET_FORM_STEP,

  UPLOAD_OWNER_PASSPORT,
  SET_PART_3_PAGE_DIRECTION,

  OPEN_PART_ONE_POPUP,
  CLOSE_PART_ONE_POPUP,

  OPEN_TC_POPUP,
  CLOSE_TC_POPUP,
} from "../ActionTypes";


export const saveFormDataPartOne = (payload) => ({
  type: SAVE_FORM_DATA_PART_ONE,
  payload
})

export const saveFormDataPartOneSuccess = (payload) => ({
  type: SAVE_FORM_DATA_PART_ONE_SUCCESS,
  payload
})

export const saveFormDataPartTwo = (payload) => ({
  type: SAVE_FORM_DATA_PART_TWO,
  payload
})

export const saveFormDataPartTwoSuccess = (payload) => ({
  type: SAVE_FORM_DATA_PART_TWO_SUCCESS,
  payload
})

export const saveFormDataPartThree = (payload) => ({
  type: SAVE_FORM_DATA_PART_THREE,
  payload
})

export const saveFormDataPartThreeSuccess = (payload) => ({
  type: SAVE_FORM_DATA_PART_THREE_SUCCESS,
  payload
})

export const sendTrainingRegDataToApi = payload => ({
  type: SEND_TRAINING_REG_DATA_TO_API,
  payload
})

export const tregFetchAllStates = payload => ({
  type: TREG_FETCH_ALL_STATES,
  payload
})

export const tregFetchAllStatesSuccess = payload => ({
  type: TREG_FETCH_ALL_STATES_SUCCESS,
  payload
})


export const registerTrainingCentre = payload => ({
  type: REGISTER_TRAINING_CENTRE,
  payload
})

export const registerTrainingCentreSuccess = payload => ({
  type: REGISTER_TRAINING_CENTRE_SUCCESS,
  payload
})

export const registerTrainingCentreFailure = payload => ({
  type: REGISTER_TRAINING_CENTRE_FAILURE,
  payload
})

export const resetTrainingCentreReg = payload => ({
  type: RESET_TRAINING_CENTRE_REG,
  payload
})



export const fetchAllActiveSkillsTreg = payload => ({
  type: FETCH_ALL_ACTIVE_SKILLS_TREG,
  payload
})

export const fetchAllActiveSkillsTregSuccess = payload => ({
  type: FETCH_ALL_ACTIVE_SKILLS_TREG_SUCCESS,
  payload
})

export const nextFormStep = () => ({
  type: NEXT_FORM_STEP
})

export const previousFormStep = () => ({
  type: PREVIOUS_FORM_STEP
})

export const resetFormStep = () => ({
  type: RESET_FORM_STEP
})

export const uploadOwnerPassport = (payload) => ({
  type: UPLOAD_OWNER_PASSPORT,
  payload
})

export const openPartOnePopup = () => ({
  type: OPEN_PART_ONE_POPUP,
})

export const closePartOnePopup = () => ({
  type: CLOSE_PART_ONE_POPUP,
})

export const openTcPopup = payload => ({
  type: OPEN_TC_POPUP,
  payload
})

export const closeTcPopup = () => ({
  type: CLOSE_TC_POPUP
})

export const setPart3PageDirection = payload => ({
  type: SET_PART_3_PAGE_DIRECTION,
  payload
})